import { InjectionToken } from '@angular/core';
import type { WishlistPersistentMemoryStore } from '../types/wishlist-persistent-memory-store.interface';

export const WISHLIST_PERSISTENT_MEMORY_STORE = new InjectionToken<WishlistPersistentMemoryStore>(
  'WISHLIST_PERSISTENT_MEMORY_STORE',
);
